<div class="columnHeaderContainer" [ngStyle]="{ 'width': (params.column.actualWidth-30).toString() + 'px' }"
    [ngbPopover]="params.displayName" container="body" popoverClass="CXoneMgtPopover" placement="top-left"
    triggers="mouseenter:mouseleave" [openDelay]="400"
    [disablePopover]="params.displayName === null || params.displayName === '' || this.hidePopover">
    <div (click)="onSortRequested($event)" class="customHeaderLabel">
        <span class="customHeaderText" [id]="this.id">{{ params.displayName }}</span>
        <span class="customeHeaderSort sortIcons mb-0 float-left">
            <svg *ngIf="ascSort" class="icon-10" style="fill: #758994;">
                <use href="../App_Themes/CXone/icons/arrow-up.svg#arrow-up"></use>
            </svg>
            <svg *ngIf="descSort" class="icon-10" style="fill: #758994;">
                <use href="../App_Themes/CXone/icons/arrow-down.svg#arrow-down"></use>
            </svg>
        </span>
    </div>
    <div  *ngIf="params.enableMenu" #menuButton class="customHeaderMenuButton" (click)="onMenuClicked()">
        <svg  class="icon-20 fill-iconMenu">
            <use href="../App_Themes/CXone/icons/widget-menu.svg#widget-menu"></use>
        </svg>
    </div>
</div>